import { render, staticRenderFns } from "./RedeNascionalPrestadoresDownload.vue?vue&type=template&id=0ce22f0c"
import script from "./RedeNascionalPrestadoresDownload.vue?vue&type=script&lang=js"
export * from "./RedeNascionalPrestadoresDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports